<wiz-vgroup #noMeasure 
  class="section-container"
  [visible]="!hasMeasure" width="100%" height="100%" padding="5px" verticalAlign="center" horizontalAlign="center">
  <wiz-label [wizLabel]="'$.measure.choose.first.$'"></wiz-label>
</wiz-vgroup>

<wiz-vgroup class="section-container"
  #vgDetailZone
  wizValidationContainer
  height="100%"
  width="100%"
  padding="5px"
  [wizDisabled]="cantUpdate"
  [visible]="hasMeasure"
>

  <wiz-vgroup #headGP  width="100%" class="section-container" padding="5px"><!--### zone d'entête (label et level) ###-->
    <wiz-label #tiLabel class="smallTitleLabel"></wiz-label>
    <wiz-translation-basic
    #trsLabel
    [wizLabel]="'$.common.label.$'"
    width="100%"
    [wizMandatory]="false"></wiz-translation-basic>

    <wiz-translation-basic
    #trsDesc
    [wizTranslationMode]="'textarea'"
    height="80px"
    [wizLabel]="'$.common.description.$'"
    width="100%"
    [wizMandatory]="false"></wiz-translation-basic>
    <wiz-hgroup width="100%" height="80px" verticalAlign="start"> <!-- gestion du type de donnée et des settings-->
      <wiz-dropdown
      #ddDataKind
      width="200px"
      [wizLabelField]="'trsLabel'"
      [wizLabel]="'$.measure.datakind.$'"
      [wizMandatory]="true"
    ></wiz-dropdown>
      <wiz-dropdown
      #ddFunc
      width="150px"
      [wizDataProvider] = "functionDS"
      [wizLabelField]="'fullName'"
      [wizLabel]="'$.measure.defaultagg.$'"
      wizPanelWidth="250px"
    ></wiz-dropdown>


      <wiz-text-area
        #taSettings
        visible="false"
        [wizLabel]="'$.mesure.settings.$'"
        width="100%"
        height="100%"
        [wizMaxChars]="2000"
      ></wiz-text-area>

    </wiz-hgroup>

  </wiz-vgroup>

  <wiz-vgroup height="100%" width="100%" style="overflow: auto" wizValidationContainer>
    <wiz-vgroup #formatNumberGP wizValidationContainer width="100%" class="section-container" padding="5px"
      ><!--### check négatif & nbdécimal ###-->
      <wiz-hgroup verticalAlign="center" gap="10">
        <wiz-checkbox #cbNegative [wizLabel]="'$.measure.allowNegative.$'" width="150px"></wiz-checkbox>
        <wiz-numeric-input
          #niNbDecimal
          [wizLabel]="'$.measure.nbDecimal.$'"
          width="200px"
          [allowNegative]="false"
          [nbDecimal]="0"
          [wizMaxNumber]="10"
          [wizMinNumber]="0"
        ></wiz-numeric-input>
      </wiz-hgroup>
      <wiz-hgroup gap="10" wizValidationContainer>
        <!--### gestion des limites de nombres et de texte ###-->
        <wiz-numeric-input
          #niMinValue
          [wizLabel]="'$.measure.minValue.$'"
          [wizMaxChars]="50"
          width="120px"
          wizValidator
          [wizShowErrors]="true"
        ></wiz-numeric-input>
        <wiz-numeric-input
          #niMaxValue
          [wizLabel]="'$.measure.maxValue.$'"
          [wizMaxChars]="50"
          width="120px"
          wizValidator
          [wizShowErrors]="true"
        ></wiz-numeric-input>
      </wiz-hgroup>
    </wiz-vgroup>

    <!--### gestion des limites de charactères sur texte -->
    <wiz-hgroup #formatTextGP wizValidationContainer width="100%" class="section-container" padding="5px">
      <wiz-numeric-input
      #niTextMinValue
      [wizLabel]="'$.measure.minValue.$'"
      [wizMaxChars]="50"
      width="120px"
      wizValidator [wizShowErrors]="true"></wiz-numeric-input>
    <wiz-numeric-input
      #niTextMaxValue
      [wizLabel]="'$.measure.maxValue.$'"
      [wizMaxChars]="50"
      width="120px"
      wizValidator [wizShowErrors]="true"></wiz-numeric-input>
      <wiz-text-input
      #tiRegex
      [wizLabel]="'$.measure.edit.regex.$'"
      [wizMaxChars]="250"
      width="120px"
    ></wiz-text-input>
    <wiz-checkbox #cbUpper wizLabel="$.arg.uppercase.$"></wiz-checkbox>
    </wiz-hgroup>


    <!--### gestion des limites de dates ###-->
    <wiz-hgroup #formatDateGP wizValidationContainer width="100%" class="section-container" padding="5px">
      <wiz-datefield
        #daMinValue
        wizValidator
        [wizShowErrors]="true"
        wizFocusMode="PASS"
        [wizLabel]="'$.measure.minValue.$'"
        width="200px"
      ></wiz-datefield>
      <wiz-datefield
        #daMaxValue
        wizValidator
        [wizShowErrors]="true"
        wizFocusMode="PASS"
        [wizLabel]="'$.measure.maxValue.$'"
        width="200px"
      ></wiz-datefield>
    </wiz-hgroup>

    <wiz-vgroup #formatConstantGP wizValidationContainer width="100%" class="section-container" padding="5px"
      ><!--### gestion des constantes ###-->
      
      <wiz-text-input
        #tiConstantValue
        [wizLabel]="'$.datatype.constant.value.$'"
        [wizMaxChars]="250"
        width="200px"
      ></wiz-text-input>
      
    </wiz-vgroup>

    <wiz-vgroup #styleFormatGP wizValidationContainer width="100%" class="section-container" padding="5px"
      ><!--### zone d'entête (label et level) ###-->
      <wiz-hgroup width="100%">
        <wiz-dropdown
          #ddFormat
          width="200px"
          [wizLabelField]="'trsLabel'"
          [wizLabel]="'$.format.title.$'"
        ></wiz-dropdown>
        <wiz-dropdown #ddStyle width="200px" [wizLabelField]="'code'" [wizLabel]="'$.style.css.$'"></wiz-dropdown>
      </wiz-hgroup>
    </wiz-vgroup>

    <wiz-vgroup #formulaIGP wizValidationContainer width="100%" class="section-container" padding="5px">
      <wiz-checkbox #cbIVisible [wizLabel]="'$.measure.visible.$'" width="200px"></wiz-checkbox>
      <wiz-checkbox #cbEditable [wizLabel]="'$.measure.editable.$'" width="200px"></wiz-checkbox>
      <wiz-hgroup width="100%" height="100%" wizValidationContainer>
        <wiz-text-area
          #taI
          [wizLabel]="'$.mesure.formula.i.$'"
          [wizShowErrors]="true"
          width="100%"
          height="100%"
          [wizValidator]="formulaIValidator()"
          [wizMaxChars]="255"
        ></wiz-text-area>
        <wiz-icon #fxI style="cursor: pointer; font-size: 20px" (click)="showFormuleEditor('I')" [wizTooltip]="'$.formula.show.editor.$'" tooltipPlacement="left">formula</wiz-icon>
      </wiz-hgroup>

      <!--### fonction de contrôle d'édition ###-->
      <wiz-vgroup #editRestrictGP wizValidationContainer [visible]="isEditable" width="100%" class="section-container" padding="5px">
        <wiz-hgroup  wizValidationContainer width="100%" height="80px">
          <wiz-text-area
            #taEditRestrict
            [wizLabel]="'$.measure.edit.restrict.$'"
            [wizShowErrors]="true"
            width="100%"
            height="100%"
            [wizValidator]="formulaRValidator()"
            [wizShowErrors]="true"
            [wizMaxChars]="255"
          ></wiz-text-area>
          <wiz-icon #fxEditRestrict style="cursor: pointer; font-size: 20px" (click)="showFormuleEditor('R')" [wizTooltip]="'$.formula.show.editor.$'" tooltipPlacement="left"
            >formula</wiz-icon>
        </wiz-hgroup>
        <wiz-translation-basic
        #trsRestrictMsg
        wizValidator
        [wizLabel]="'$.arg.restrict.msg.$'"
        width="100%"
        [wizShowErrors]="false"
        [wizMandatory]="false"></wiz-translation-basic>
      </wiz-vgroup>

      <!--### valeur par défaut et trigger ###-->
      <wiz-vgroup #editTriggerGP wizValidationContainer [visible]="isEditable" width="100%" class="section-container" padding="5px">
        <wiz-hgroup  wizValidationContainer width="100%" height="80px">
          <wiz-text-area
            #taEditDefault
            [wizLabel]="'$.measure.edit.default.$'"
            [wizShowErrors]="true"
            width="100%"
            height="100%"
            [wizValidator]="formulaDValidator()"
            [wizShowErrors]="true"
            [wizMaxChars]="255"
          ></wiz-text-area>
          <wiz-icon #fxEditDefault style="cursor: pointer; font-size: 20px" (click)="showFormuleEditor('D')" [wizTooltip]="'$.formula.show.editor.$'" tooltipPlacement="left"
            >formula</wiz-icon>
        </wiz-hgroup>
        <wiz-hgroup  wizValidationContainer width="100%" height="80px">
          <wiz-text-area
            #taEditTrigger
            [wizLabel]="'$.measure.edit.trigger.$'"
            [wizShowErrors]="true"
            width="100%"
            height="100%"
            [wizValidator]="formulaGValidator()"
            [wizShowErrors]="true"
            [wizMaxChars]="255"
          ></wiz-text-area>
          <wiz-icon #fxEditTrigger style="cursor: pointer; font-size: 20px" (click)="showFormuleEditor('G')" [wizTooltip]="'$.formula.show.editor.$'" tooltipPlacement="left"
            >formula</wiz-icon>
        </wiz-hgroup>
      </wiz-vgroup>


      <!--### gestion de la fonction de validation ###-->
      <wiz-vgroup #valueControlGP wizValidationContainer width="100%" class="section-container" padding="5px">
        <wiz-hgroup width="100%" height="80px" wizValidationContainer>
          <!--### fonction de validation ###-->
          <wiz-text-area
            #tavalueControl
            [wizLabel]="'$.measure.valueControl.$'"
            [wizShowErrors]="true"
            width="100%"
            height="100%"
            [wizValidator]="formulaCValidator()"
            [wizShowErrors]="true"
            [wizMaxChars]="255"
          ></wiz-text-area>
          <wiz-icon #fxValueControl style="cursor: pointer; font-size: 20px" (click)="showFormuleEditor('C')" [wizTooltip]="'$.formula.show.editor.$'" tooltipPlacement="left"
            >formula</wiz-icon>
        </wiz-hgroup>
        <wiz-translation-basic
        #trsValueControlMsg
        wizValidator
        [wizLabel]="'$.arg.valuecontrol.msg.$'"
        width="100%"
        [wizShowErrors]="true"
        [wizMandatory]="false"></wiz-translation-basic>
      </wiz-vgroup>

      <!--### gestion du crossVision ###-->
      <wiz-vgroup #crossGP wizValidationContainer width="100%" height="80px" class="section-container" padding="5px">
          <wiz-text-area
            #taCrossRef
            [wizLabel]="'$.measure.crossref.$'"
            width="100%"
            height="100%"
            [wizMaxChars]="500"
          ></wiz-text-area>
      </wiz-vgroup>


    </wiz-vgroup>




    <wiz-vgroup #formulaOtherGP wizValidationContainer width="100%" class="section-container" padding="5px">
      <wiz-checkbox #cbSVisible [wizLabel]="'$.measure.visible.$'" width="200px"></wiz-checkbox>
      <wiz-hgroup width="100%" height="80px" wizValidationContainer>
        <wiz-text-area
          #taS
          [wizLabel]="'$.mesure.formula.s.$'"
          [wizShowErrors]="true"
          width="100%"
          height="100%"
          [wizValidator]="formulaSValidator()"
          [wizMaxChars]="255"
        ></wiz-text-area>
        <wiz-icon #fxS style="cursor: pointer; font-size: 20px" (click)="showFormuleEditor('S')" [wizTooltip]="'$.formula.show.editor.$'" tooltipPlacement="left">formula</wiz-icon>
      </wiz-hgroup>
      <wiz-checkbox #cbFVisible [wizLabel]="'$.measure.visible.$'" width="200px"></wiz-checkbox>
      <wiz-hgroup width="100%" height="80px" wizValidationContainer>
        <wiz-text-area
          #taF
          [wizLabel]="'$.mesure.formula.f.$'"
          [wizShowErrors]="true"
          width="100%"
          height="100%"
          [wizValidator]="formulaFValidator()"
          [wizMaxChars]="255"
        ></wiz-text-area>
        <wiz-icon #fxF style="cursor: pointer; font-size: 20px" (click)="showFormuleEditor('F')" [wizTooltip]="'$.formula.show.editor.$'" tooltipPlacement="left">formula</wiz-icon>
      </wiz-hgroup>
      <wiz-checkbox #cbTVisible [wizLabel]="'$.measure.visible.$'" width="200px"></wiz-checkbox>
      <wiz-hgroup width="100%" height="80px" wizValidationContainer>
        <wiz-text-area
          #taT
          [wizLabel]="'$.mesure.formula.t.$'"
          [wizShowErrors]="true"
          width="100%"
          height="100%"
          [wizValidator]="formulaTValidator()"
          [wizMaxChars]="255"
        ></wiz-text-area>
        <wiz-icon #fxT style="cursor: pointer; font-size: 20px" (click)="showFormuleEditor('T')" [wizTooltip]="'$.formula.show.editor.$'" tooltipPlacement="left">formula</wiz-icon>
      </wiz-hgroup>
    </wiz-vgroup>
  </wiz-vgroup>

  <wiz-vgroup width="100%" height="70px" horizontalAlign="end" class="section-container" padding="5px">
    <wiz-hgroup width="100%">
      <wiz-icon
        #btDelete
        style="cursor: pointer; font-size: 20px"
        width="15px"
        (click)="doDelete()"
        [wizTooltip]="'$.common.delete.$'"
        >delete</wiz-icon
      >
      <wiz-spacer width="100%"></wiz-spacer>
      <wiz-button
        #btOk
        width="200px"
        [wizIcon]="'arrow-right'"
        [wizLabel]="'$.common.save.modification.$'"
        [wizDisabled]="true"
        [iconPlacement]="'right'"
        (click)="save()"
      ></wiz-button>
    </wiz-hgroup>
    <wiz-button
      #btCancel
      class="cancel-button"
      [wizIcon]="'arrow-left'"
      [wizLabel]="'$.common.cancel.modification.$'"
      [wizDisabled]="true"
      (click)="cancel()"
    ></wiz-button>
  </wiz-vgroup>
</wiz-vgroup>
